import request from './store/request';
import { s_r_e as lang } from '~/lang/ru';
import { map, length } from 'ramda';
import { Can } from '@casl/vue';
import { Badge, Themes } from '~/components/Badge';
import { Modal } from '~/4trend/Modal';
import { ActView } from './ActView';

/**
 *
 * @param {string} status
 * @returns
 */
const getThemePropsByStatus = (status) => {
	switch (status) {
		case 'Согласование акта':
			return Themes.Pink;
		case 'Акт согласован':
			return Themes.Blue;
		case 'Отклонён':
			return Themes.Red;
	}
}

const createActForm = (act) => import('./ActFormModal')
	.then(({ ActFormModal }) => {
		const modal = new Vue(ActFormModal);

		if (act)
			modal.act = act;

		modal.$mount();
		document.body.appendChild(modal.$el);
		modal.$refs.modal.show();

		return modal;
	});

const createActConfirm = (act) => import('./ActConfirmModal')
	.then(({ ActConfirmModal }) => {
		const modal = new Vue(ActConfirmModal);

		if (act)
			modal.act = act;

		modal.$mount();
		document.body.appendChild(modal.$el);
		modal.$refs.modal.show();

		return modal;
	});

const createActReject = (act) => import('./ActRejectModal')
	.then(({ ActRejectModal }) => {
		const modal = new Vue(ActRejectModal);

		if (act)
			modal.act = act;

		modal.$mount();
		document.body.appendChild(modal.$el);
		modal.$refs.modal.show();

		return modal;
	});

export const createActView = (act) => {
	const modal = new Vue({
		mounted() {
			this.$refs.modal.$el.querySelector('.modal-dialog').classList.add('modal-dialog-centered', 'modal-lg');
		},
		beforeDestroy() {
			this.$el.parentElement.removeChild(this.$el);
		},
		computed: {
			title: () => {
				let title = `${lang('ACT_MODAL')} #${act?.actNumber}`;

				if (act?.formType)
					title += ` (${act.formType})`;

				if (act?.requestNumber)
					title += ` по заказу №${act.requestNumber}`;

				return title;
			},
		},
		render() {
			return (
				<Modal
					ref="modal"
					title={ this.title }
					onHidden={ () => this.$destroy() }
				>
					<ActView act={ act }/>
				</Modal>
			);
		},
	});

	modal.$mount();
	document.body.appendChild(modal.$el);
	modal.$refs.modal.show();

	return modal;
}

const ActListItem = {
	name: 'ActListItem',
	props: {
		act: Object,
	},
	methods: {
		edit() {
			createActForm(this.act);
		},
		confirm() {
			createActConfirm(this.act);
		},
		reject() {
			createActReject(this.act);
		},
		resetPrint() {
			const form = document.createElement('form');
			const inputActId = document.createElement('input');
			const formType = document.createElement('input');

			formType.name = 'form';
			formType.value = 'printRefresh';
			inputActId.name = 'ACT_ID';
			inputActId.value = this.act.id;

			form.method = 'post';
			form.append(formType, inputActId);
			form.hidden = true;
			document.body.appendChild(form);
			form.submit();
		},
		view() {
			createActView(this.act);
		},
	},
	render() {
		return (
			<div>
				<div>
					Акт #{this.act.actNumber}
					{ this.act.formType ? ` (${this.act.formType})` : null }
					<Badge
						class="ml-4"
						text={ this.act.status }
						{ ...{ props: getThemePropsByStatus(this.act.status) } }
					/>
					{ this.act.canEdit ? (
						<Can I="update" an="Act">
							<button
								type="button"
								class="ml-4 button button_theme_secondary-ghost button_size_s"
								onClick={ () => this.edit() }
							>
								{ lang('EDIT') }
							</button>
						</Can>
					) : null }
					<button
						type="button"
						class="ml-4 button button_theme_secondary-ghost button_size_s"
						onClick={ () => this.view() }
					>
						Посмотреть
					</button>
					{ !this.act.isConfirmed ? (
						<Can I="confirm" an="Act">
							<button
								class="ml-4 button button_theme_secondary-ghost button_size_s"
								onClick={ () => this.confirm() }
								type="button"
							>
								{ lang('CONFIRM') }
							</button>
						</Can>
					) : null }
					{ !this.act.isRejected && !this.act.isConfirmed ? (
						<Can I="reject" an="Act">
							<button
								type="button"
								class="ml-4 button button_theme_secondary-ghost button_size_s"
								onClick={ () => this.reject() }
							>
								{ lang('REJECT') }
							</button>
						</Can>
					) : null }
					{ this.act.canPrint ? (
						<Can I="print" an="Act">
							<a
								class="ml-4 button button_theme_secondary-ghost button_size_s"
								href={`${window.location.pathname}?print=true&type=act` }
								target="_blank"
							>
								{ lang('PRINT') }
							</a>
						</Can>
					) : null }
					{ this.act.isPrinted ? (
						<Can I="printRefresh" an="Act">
							<button
								type="button"
								class="ml-4 button button_theme_secondary-ghost button_size_s"
								onClick={ () => this.resetPrint() }
							>
								{ lang('RESET_PRINT') }
							</button>
						</Can>
					) : null }
				</div>
				{ this.act.isRejected && this.act.rejectionReason ? (
					<p>
						<b>{ lang('REJECTION_REASON') } ({ lang('CONTACT_SUPPORT') })</b>: { this.act.rejectionReason }
					</p>
				) : null }
			</div>
		)
	}
}

export const ActList = {
	name: 'ActList',
	methods: {
		createAct() {
			createActForm();
		},
	},
	render() {
		return (
			<div>
				{ true ? (
					length(request.acts) ? (
						map((act) => (
							<ActListItem act={ act } />
						), request.acts)
					) : (
						<button class="request-info-link" onClick={ () => this.createAct() } type="button">
							{ lang('DO_ACT') }
						</button>
					)
				) : (
					<p>{ lang('DO_DIAGNOSE') }</p>
				) }
			</div>
		);
	}
}
